import type { ID } from '@octopus-do/octopus-project-core'
import type { WorkspaceItem } from '@store/reducers/dashboard/types'
import type React from 'react'

import { FolderMenu, FolderMenuTrigger, FolderRename } from './components'

interface Props {
  folder: WorkspaceItem
  i: number
  renamingFolder: ID | null
  showFolderAccess: boolean
  workspaceId: ID
  lastIdx: number
  activeFolder: ID | null
  onHideInput: () => void
  onClick: (keys: string[]) => void
}

export const FolderRenderer: React.FC<Props> = ({
  folder,
  i,
  renamingFolder,
  workspaceId,
  lastIdx,
  activeFolder,
  onHideInput,
  onClick,
  showFolderAccess,
}) => {
  if (renamingFolder === folder.id) {
    return (
      <FolderRename
        title={folder.title}
        workspaceId={workspaceId}
        id={folder.id}
        onHideRenameInput={onHideInput}
      />
    )
  }

  return (
    <FolderMenu
      key={folder.id}
      id={folder.id}
      title={folder.title}
      disabledMoveUp={i === 0}
      disabledMoveDown={i === lastIdx}
      showAccess={showFolderAccess}
      onClick={onClick}
    >
      <FolderMenuTrigger
        activeFolder={activeFolder}
        folder={folder}
        workspaceId={workspaceId}
      />
    </FolderMenu>
  )
}
